import React from "react";
import "./HousekeepingServices.css";

// 👉 Replace with your own small icon
import ServiceIcon from "../../Image/HouseKeeping/rightthick.png";

const services = [
  "Lawn mowing & maintenance",
  "Plant pruning & trimming",
  "Seasonal flower plantation",
  "Shrub shaping & grooming",
  "Tree care & maintenance",
  "Fertilization & manuring",
  "Watering schedule management",
  "Weed control & removal",
  "Pest & disease management",
  "Soil testing & treatment",
  "Garden bed maintenance",
  "Green belt upkeep"
];


const steps = [
  {
    number: "01",
    title: "Landscape Assessment",
    desc: "Evaluate existing landscape, soil conditions, and create maintenance plan.",
  },
  {
    number: "02",
    title: "Team & Schedule Setup",
    desc: "Deploy horticulture experts and establish regular maintenance schedules.",
  },
  {
    number: "03",
    title: "Regular Maintenance",
    desc: "Execute mowing, pruning, watering, and plant care as per seasonal needs.",
  },
  {
    number: "04",
    title: "Monitoring & Enhancement",
    desc: "Monitor plant health, implement improvements, and seasonal plantation",
  },
];

const LandscapingServices = () => {
  return (
    <>
      {/* ---------------- SERVICES SECTION ---------------- */}
      <section className="hk-services-section">
        <h2 className="hk-section-title">Our Service Includes</h2>

        <div className="hk-services-grid">
          {services.map((item, index) => (
            <div key={index} className="hk-service-card">
              <img src={ServiceIcon} alt="service" className="hk-service-img" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ---------------- PROCESS SECTION ---------------- */}
      <section className="hk-process-section">
        <div className="hk-process-tag">Our Process</div>
        <h2 className="hk-section-title">Our Landscape Maintenance Process</h2>

        <div className="hk-process-grid">
          {steps.map((step, index) => (
            <div key={index} className="hk-process-card">
              <div className="hk-process-number">{step.number}</div>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default LandscapingServices;
